export const app = {
  shortName: "TK",
  longName: "Track&Keep",
};

export const client = {
  currentVersion: "3.0.3",
};
